// extracted by mini-css-extract-plugin
module.exports = {"s1fshi15":"s1fshi15","s11081fy":"s11081fy"};